import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import './LoginError.css';

const LoginError = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [gatewayLoginUrl, setGatewayLoginUrl] = useState('');
  const message = searchParams.get('error') || 'Access denied or session invalid.';

  useEffect(() => {
    let cancelled = false;
    api.get('/Auth/GatewayLoginUrl')
      .then((res) => {
        if (!cancelled && res.data?.gatewayLoginUrl) {
          setGatewayLoginUrl(res.data.gatewayLoginUrl.trim());
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleReturnToLogin = () => {
    if (gatewayLoginUrl) {
      window.location.href = gatewayLoginUrl;
    } else {
      navigate('/login', { replace: true });
    }
  };

  return (
    <div className="login-error-page">
      <div className="login-error-content">
        <div className="login-error-code">Access Denied</div>
        <h1 className="login-error-title">Sorry, we couldn't sign you in</h1>
        <p className="login-error-message">{message}</p>
        <p className="login-error-detail">
          The link you followed may be invalid, or your account might be inactive or no longer allowed to access this application.
        </p>
        <div className="login-error-illustration" aria-hidden="true">
          <svg viewBox="0 0 200 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="75" r="45" stroke="currentColor" strokeWidth="2" opacity="0.5" />
            <path d="M70 95 a30 30 0 0 1 60 0" stroke="currentColor" strokeWidth="2" opacity="0.5" fill="none" />
            <circle cx="100" cy="68" r="8" stroke="currentColor" strokeWidth="2" opacity="0.6" fill="none" />
            <path d="M55 120 L75 100 M145 120 L125 100" stroke="currentColor" strokeWidth="2" opacity="0.4" strokeLinecap="round" />
            <path d="M100 85 L100 55 M85 70 L115 70" stroke="currentColor" strokeWidth="1.5" opacity="0.7" strokeLinecap="round" />
            <circle cx="100" cy="140" r="12" stroke="currentColor" strokeWidth="2" opacity="0.4" fill="none" />
            <path d="M88 140 L92 130 M112 140 L108 130 M100 128 L100 140" stroke="currentColor" strokeWidth="1" opacity="0.5" strokeLinecap="round" />
          </svg>
        </div>
        <button type="button" className="login-error-btn" onClick={handleReturnToLogin}>
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default LoginError;
